module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "life-buoy.285e728c.webp";